import api from '../services/api';

export type GetFeaturesResponse = {
    data: {
        id: number;
        key: string;
        enabled: boolean;
    }[];
};

export const getFeatures = (): Promise<string[]> => {
    return api
        .get('/availableFeatures')
        .then(({ data }: GetFeaturesResponse) =>
            data.map((feature) => feature.key)
        );
};
